














































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { Dialog, format } from 'quasar'
import ModalDialog from 'components/modals/Dialog.vue'

@Component({
  components: {
    ModalDialog
  }
})
export default class Timer extends Vue {
  pad = format.pad
  hour = 0
  minute = 0
  second = 0

  @Prop({ default: '' })
  readonly title!: string

  @Prop({ default: '' })
  readonly message!: string

  @Prop({ default: null })
  readonly value!: number | null

  @Prop({ default: false })
  readonly hours!: boolean

  @Prop({ default: false })
  readonly minutes!: boolean

  @Prop({ default: false })
  readonly seconds!: boolean

  @Ref()
  readonly dialog!: ModalDialog

  get total () {
    return this.second + 60 * this.minute + 60 * 60 * this.hour
  }

  show () { this.dialog.show() }
  hide () { this.dialog.hide() }

  created () {
    const value = this.value || 0
    this.second = this.seconds ? value % 60 : 0
    this.minute = this.minutes ? Math.floor(value / 60) % 60 : 0
    this.hour = this.hours ? Math.floor(value / 60 / 60) % 24 : 0
  }

  ok (action: string) {
    if (action === 'right') {
      this.$emit('ok', this.total || null)
    } else if (action === 'middle') {
      this.$emit('ok', null)
    } else {
      this.hide()
    }
  }
}

export async function select (parent: Vue, props = {}): Promise<number | null> {
  return new Promise((resolve, reject) => {
    const dialog = Dialog.create({
      parent,
      component: Timer,
      ...props
    }).onOk((value: number | null) => {
      resolve(value)
      dialog.hide()
    })
  })
}
